export function toDecimal(value: number) {
  return `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}

export function toFixed(value: number) {
  return `${value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}